jQuery(document).ready(function($) {

	$('.calculator-block form').validate();
 
});